// SPDX-License-Identifier: AGPL-3.0-or-later

export const PASSKEY_MIGRATION_RP_ID = 'fluxer.com';

export const PASSKEY_BRIDGE_PATH = '/passkey-bridge';

export const PASSKEY_BRIDGE_RETURN_FRAGMENT_KEY = 'passkey-bridge';

export const PASSKEY_BRIDGE_CHANNEL = 'fluxer:passkey-bridge';
